/**
 * @brief Office 공간안내 페이지
 * @details
 * @author hyekyoungKang
 * @date 2024-06-10
 * @version 0.0.1
 */

import React from "react";
import styles from "./SpaceGuide.module.scss";
import SubBanner from "../../components/common/subBanner/SubBanner";
import SpaceGuideCardSlide from "../../components/pagesComponents/spaceGuide/SpaceGuideCardSlide";
import SpaceGuideCardTitle from "../../components/pagesComponents/spaceGuide/SpaceGuideCardTitle";
import MetaTags from "../../components/meta/MetaTag";

const SpaceGuide = () => {
  const datas = [
    {
      id: 1,
      imgs: [
        "./assets/images/office_single01",
        "./assets/images/office_single02",
        "./assets/images/office_single03",
      ],
      title: "1인실",
      desc: "1인 기업 또는 프리랜서 분들을 위한 공간으로, 독립적인 업무가 가능합니다.",
      iconData: [
        "기본 데스크",
        "개별 서랍장",
        "개별 디지털 도어록",
        "개별 냉난방",
        "초고속 인터넷",
        "보안 시스템",
        "공용 라운지",
        "24시간 이용 가능",
      ],
    },
    {
      id: 2,
      imgs: [
        "./assets/images/office_double01",
        "./assets/images/office_double02",
        "./assets/images/office_double03",
      ],
      title: "2인실",
      desc: "2인 이하의 소규모 기업을 위한 공간으로, 독립적인 업무가 가능합니다.",
      iconData: [
        "기본 데스크",
        "개별 서랍장",
        "개별 디지털 도어록",
        "개별 냉난방",
        "초고속 인터넷",
        "보안 시스템",
        "공용 라운지",
        "24시간 이용 가능",
      ],
    },
    {
      id: 3,
      imgs: [
        "./assets/images/office_triple01",
        "./assets/images/office_triple02",
        "./assets/images/office_triple03",
        "./assets/images/office_triple04",
      ],
      title: "3인실",
      desc: "3인 이하의 소규모 기업을 위한 공간으로, 독립적인 업무가 가능합니다.",
      iconData: [
        "기본 데스크",
        "개별 서랍장",
        "개별 디지털 도어록",
        "개별 냉난방",
        "초고속 인터넷",
        "보안 시스템",
        "공용 라운지",
        "24시간 이용 가능",
      ],
    },
    {
      id: 4,
      imgs: ["./assets/images/office_quad01", "./assets/images/office_quad02"],
      title: "4인실",
      desc: "4인 이하의 소규모 기업을 위한 공간으로, 독립적인 업무가 가능합니다.",
      iconData: [
        "기본 데스크",
        "개별 서랍장",
        "개별 디지털 도어록",
        "개별 냉난방",
        "초고속 인터넷",
        "보안 시스템",
        "공용 라운지",
        "24시간 이용 가능",
      ],
    },
    {
      id: 5,
      imgs: [
        "./assets/images/office_5person01",
        "./assets/images/office_5person02",
      ],
      title: "5인실",
      desc: "5인 이하의 소규모 기업을 위한 공간으로, 독립적인 업무가 가능합니다.",
      iconData: [
        "기본 데스크",
        "개별 서랍장",
        "개별 디지털 도어록",
        "개별 냉난방",
        "초고속 인터넷",
        "보안 시스템",
        "공용 라운지",
        "24시간 이용 가능",
      ],
    },
    {
      id: 8,
      imgs: [
        "./assets/images/office_8person01",
        "./assets/images/office_8person02",
      ],
      title: "8인실",
      desc: "8인 이하의 소규모 기업을 위한 공간으로, 독립적인 업무가 가능합니다.",
      iconData: [
        "기본 데스크",
        "개별 서랍장",
        "개별 디지털 도어록",
        "개별 냉난방",
        "초고속 인터넷",
        "보안 시스템",
        "공용 라운지",
        "24시간 이용 가능",
      ],
    },
    {
      id: 9,
      imgs: [
        "./assets/images/office_meeting01",
        "./assets/images/office_meeting02",
        "./assets/images/office_meeting03",
        "./assets/images/office_meeting04",
      ],
      title: "회의실",
      desc: "크기 별로 네 개의 회의실이 구비되어 있으며 예약제로 운영됩니다.",
      iconData: ["대형 모니터", "화이트보드", "초고속 인터넷"],
    },
    {
      id: 10,
      imgs: [
        "./assets/images/office_lounge01",
        "./assets/images/office_lounge02",
        "./assets/images/office_lounge03",
        "./assets/images/office_lounge04",
        "./assets/images/office_lounge05",
        "./assets/images/office_lounge07",
        "./assets/images/office_lounge08",
      ],

      title: "모두의 라운지",
      desc: "오픈된 라운지에서 자유로운 형태로의 업무가 가능합니다.",
      iconData: [
        "공용 냉난방",
        "초고속 인터넷",
        "24시간 이용 가능",
        "탕비실",
        "전자레인지",
        "정수기",
        "냉장고",
        "무료 커피",
        "간식 구매 가능",
      ],
    },
    {
      id: 11,
      imgs: [
        "./assets/images/office_facilities01",
        "./assets/images/office_facilities02",
        "./assets/images/office_facilities03",
        "./assets/images/office_facilities04",
      ],

      title: "부가 시설",
      desc: "폰 부스, 파우더룸, 안마의자 등의 기타 편의시설을 이용할 수 있습니다.",
      iconData: ["폰 부스", "파우더룸", "안마의자", "사물함"],
    },
  ];

  return (
    <>
      <MetaTags title="공간안내 | 스마트워크" />
      <div className={styles.container}>
        <SubBanner title={"공간 안내"} hasMarginBottom={"8rem"} />
        <div className={styles.content}>
          {datas.map((item) => {
            return (
              <div className={styles.cardBox} key={item.title}>
                <SpaceGuideCardSlide datas={datas} item={item} />
                <SpaceGuideCardTitle item={item} />
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default SpaceGuide;
